module.exports = __webpack_public_path__ + "static/heritage-green-logo-cfc618444e349e5c421ebaea2e7204f9.jpg";